import { Component, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import { hiddenNotices } from '@state/config/config.selectors';
import { hideNoticeAction } from '@state/config/config.actions';

@UntilDestroy()
@Component({
  selector: 'app-home-notice',
  templateUrl: './notice.component.html',
  styleUrls: ['./notice.component.scss'],
})
export class NoticeComponent implements OnInit {
  public active = false;
  public slug = 'home-notice-vpc-maintenance-downtime-2023-05-26';
  protected isMobile = false;

  constructor(
    private deviceService: DeviceDetectorService,
    private store: Store<AppState>
  ) {}

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobile();
    this.store
      .select(hiddenNotices)
      .pipe(untilDestroyed(this))
      .subscribe((hiddenNotices) => {
        if (hiddenNotices.includes(this.slug)) {
          this.active = false;
        }
      });
  }

  close(): void {
    this.store.dispatch(hideNoticeAction({ notice: this.slug }));
    this.active = false;
  }
}
